import React from 'react';
import type { Author } from '~/types/blog';
import { formatDate } from '~/lib/utils';

interface AuthorInfoProps {
  author: Author;
  date: string;
}

export function AuthorInfo({ author, date }: AuthorInfoProps) {
  return (
    <div className="flex items-center gap-3">
      {author.avatar && (
        <img
          src={author.avatar}
          alt={author.name}
          className="w-12 h-12 rounded-full object-cover"
        />
      )}
      <div>
        <div className="font-semibold text-yellow-500">{author.name}</div>
        <div className="text-sm text-muted-foreground">
          {author.role} · {formatDate(date)}
        </div>
      </div>
    </div>
  );
}